module.exports = __webpack_public_path__ + "img/tuandui.172595c1.png";